import util from '@/util'
import { SEQUENCE_STATUS, SEQUENCE_STEP_STATUS, SEQUENCE_TYPES } from '@/store/modules/sequence/constants'
import moment from 'moment-timezone'

export function formatDateTime(dateString) {
  return dateString ? moment(dateString).utc().format('MM/DD/YYYY HH:mm') : '-'
}

export function getAssociateFullName(associate = {}) {
  return [associate.first_name, associate.last_name].filter(Boolean).join(' ') || '-'
}

export function getTypeTitle(type) {
  return SEQUENCE_TYPES[type]?.title || util.capitalize(type || '')
}

export function getSequenceStatusTitle(status) {
  return SEQUENCE_STATUS[status]?.title || util.capitalize(status || '')
}

export function getSequenceStatusColor(status) {
  return SEQUENCE_STATUS[status]?.color || '#6b7280'
}

export function getReviewerName(signature) {
  return signature ? [signature.first_name, signature.last_name].filter(Boolean).join(' ') || signature.email || '-' : '-'
}

export function getStepName(step) {
  return step?.body?.name || step?.body?.template?.name || step?.body?.survey?.name || '-'
}

export function getStepTitle(type) {
  switch (type) {
    case 'text':
    case 'pdf':
    case 'sign_document':
      return 'Sign Document'
    case 'video':
      return 'Video completion'
    case 'survey':
      return 'Quiz results'
    case 'attach_file':
      return 'Attached document'
    default:
      return util.capitalize(type || '')
  }
}

export function getStepTypeTitle(step) {
  return getStepTitle(step?.body?.type || step?.type)
}

export function getEvidenceTitle(step) {
  if (!step) {
    return 'Step evidence'
  }

  if (step.type === 'attach_file') {
    return 'Attached document'
  }

  switch (step.body?.type) {
    case 'video':
      return 'Video completion'
    case 'survey':
      return 'Quiz results'
    default:
      return 'Signed document'
  }
}

export function getReviewStatusTitle(status) {
  switch (status) {
    case 'approved':
      return 'Approved'
    case 'declined':
      return 'Declined'
    default:
      return 'Not reviewed'
  }
}

export function getReviewStatusColor(status) {
  switch (status) {
    case 'approved':
      return '#10b981'
    case 'declined':
      return '#ef4444'
    default:
      return '#6b7280'
  }
}

export function getAdminStepStatusTitle(step) {
  if (step.document) {
    return 'Attached'
  }

  return step.is_required ? 'Needs document' : 'Optional'
}

export function getAdminStepStatusColor(step) {
  if (step.document) {
    return '#10b981'
  }

  return step.is_required ? '#f59e0b' : '#6b7280'
}

export function getAdminRecordStatusTitle(step) {
  if (step.document) {
    return 'Attached'
  }

  return step.is_required ? 'Not attached' : 'Optional not attached'
}

export function getAdminRecordStatusColor(step) {
  if (step.document) {
    return '#10b981'
  }

  return step.is_required ? '#ef4444' : '#6b7280'
}

export function normalizeReviewAdminStep(item) {
  return {
    ...item,
    template: item.template.id,
    document: item.document ? item.document?.id : null
  }
}

export { SEQUENCE_STEP_STATUS }
